import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import css from './Enroll.module.css';

import * as courseServices from '../../../../services/courseServices';
import * as requestServices from '../../../../services/requestServices';
import * as enrollServices from '../../../../services/enrollServices';

function Enroll() {
    const { courseId } = useParams();
    const navigate = useNavigate();

    const [message, setMessage] = useState({ message: '', color: 'black' }); //check why colors are not changing
    const [courseList, setCourseList] = useState([]);
    const [openRequests, setOpenRequests] = useState([]);

    let template = {
        courseId: courseId || '',
        requestId: '',
        studentId: '',
        programId: '',
    };
    const [newData, setNewData] = useState(template);

    useEffect(() => {
        courseServices
            .getOption('list')
            .then((result) => {
                setCourseList((state) => result.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        requestServices
            .getOption('openRequests')
            .then((result) => {
                setOpenRequests((state) => result.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    const handleChange = (e) => {
        const { id, value } = e.target;
        if (id === 'courseId') {
            setNewData((state) => ({
                ...state,
                courseId: value,
            }));
        }
        if (id === 'studentId') {
            let currentRequest = filterRequests().filter((x) => Number(x.studentId) === Number(value))[0];
            setNewData((state) => ({
                ...state,
                studentId: value,
                requestId: currentRequest.requestId,
                programId: currentRequest.programId,
            }));
        }
    };

    const filterRequests = () => {
        let aircraftTypeId = Number(courseList.filter((x) => x.courseId === Number(newData.courseId))[0]?.aircraftTypeId);
        let courseTypeId = Number(courseList.filter((x) => x.courseId === Number(newData.courseId))[0]?.courseTypeId);
        let result = openRequests.filter((x) => Number(x.aircraftTypeId) === aircraftTypeId && Number(x.courseTypeId) === courseTypeId);
        return result;
    };

    const handleEnroll = async (e) => {
        e.preventDefault();
        console.log(newData);
        enrollServices
            .create(newData)
            .then((result) => {
                // console.log(result);
                setNewData((state) => ({
                    ...newData,
                    studentId: '',
                }));
                setMessage((state) => ({ message: result.message, color: 'green' })); //check why colors are not changing
                setOpenRequests((state) => state.filter((x) => Number(x.requestId) !== Number(newData.requestId)));
                return true;
            })
            .catch((err) => {
                setMessage((state) => ({ message: 'Sorry, something went wrong!', color: 'red' })); //check why colors are not changing
                console.log(message); //check why colors are not changing
                return false;
            });
    };

    return (
        <div className={css.main}>
            <form className={css.form}>
                <label htmlFor="courseId">Course: </label>
                <select id="courseId" onChange={handleChange} className={css.input} value={newData.courseId} required>
                    <option key={'na'} value={''} disabled>
                        Select course ...
                    </option>
                    {courseList.map((x) => (
                        <option key={x.courseId} value={x.courseId}>
                            {x.courseTitle}
                        </option>
                    ))}
                </select>

                <label htmlFor="studentId">Student: </label>
                <select id="studentId" onChange={handleChange} className={css.input} value={newData.studentId} required>
                    <option key={'na'} value={0}>
                        Select student ...
                    </option>
                    {filterRequests().map((x) => (
                        <option key={x.requestId} value={x.studentId}>
                            {`(${x.studentNo}) ${x.studentName} - ${x.licenseCategoryTitle}`}
                        </option>
                    ))}
                </select>

                <div className={css.submitButtons}>
                    <button type="submit" className={css.enrollButton} onClick={handleEnroll}>
                        Enroll
                    </button>
                    <button className={css.backButton} onClick={() => navigate(`/course/details/${newData.courseId}`)}>
                        Back to course
                    </button>
                </div>
                {/* Check why colors are not changing */}
                <p className={css[message.color]}>{message.message}</p>
            </form>
            <div>
                <p>
                    <b>Open requests</b>
                </p>
                {openRequests.map((x) => (
                    <p key={x.requestId}>{x.studentName}</p>
                ))}
            </div>
        </div>
    );
}

export default Enroll;
